import React from 'react';
type BadgeVariant = 'default' | 'success' | 'warning' | 'danger' | 'info';
interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
}
const variantStyles: Record<BadgeVariant, string> = {
  default: 'bg-gray-100 text-gray-700',
  success: 'bg-green-100 text-green-700',
  warning: 'bg-yellow-100 text-yellow-700',
  danger: 'bg-red-100 text-red-700',
  info: 'bg-blue-100 text-blue-700'
};
export function Badge({
  children,
  variant = 'default',
  className = ''
}: BadgeProps) {
  return <span className={`
        inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium
        ${variantStyles[variant]}
        ${className}
      `} data-id="element-205">
      {children}
    </span>;
}
// Helper function to get badge variant from invoice status
export function getInvoiceStatusVariant(status: string): BadgeVariant {
  switch (status) {
    case 'paid':
      return 'success';
    case 'sent':
      return 'warning';
    case 'draft':
      return 'info';
    case 'refunded':
    case 'voided':
      return 'danger';
    default:
      return 'default';
  }
}
// Helper function to get badge variant from subscription status
export function getSubscriptionStatusVariant(status: string): BadgeVariant {
  switch (status) {
    case 'active':
      return 'success';
    case 'paused':
      return 'warning';
    case 'canceled':
      return 'danger';
    default:
      return 'default';
  }
}
// Helper function to get badge variant from payment status
export function getPaymentStatusVariant(status: string): BadgeVariant {
  switch (status) {
    case 'succeeded':
      return 'success';
    case 'pending':
      return 'warning';
    case 'failed':
      return 'danger';
    default:
      return 'default';
  }
}